declare const window: any;

export function applicationDataExists(): boolean {
  // Check also for undefined so Test-Runners doesn't crash
  return typeof window !== "undefined" && window.ELSTR && window.ELSTR.applicationData;
}

export function configExists(): boolean {
  return applicationDataExists() && window.ELSTR.applicationData.config;
}

export function languageExists(): boolean {
  return applicationDataExists() && window.ELSTR.applicationData.language;
}

export function userExists(): boolean {
  return applicationDataExists() && window.ELSTR.applicationData.user;
}

export interface ApplicationData {
  config: object | null;
  language: object | null;
  user: object | null;
}
